<template>
  <div class="layout">
<!--    <el-container>-->
      <!-- 头部 -->
      <layout-header v-if="route.meta.isShowHeader"></layout-header>

      <!-- 主体区域 -->
      <el-main :style="{marginLeft:layoutMarginLeft+'px',marginTop:LayoutHeaderHeight+'px',padding:0}">
        <div class="nav">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :to="{ path: item.path }">
              {{item.name}}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <transition name="fade-transform">
          <keep-alive>
            <router-view
              v-if="route.meta.keepAlive"
              :style="{
							zIndex: 0,
							// minWidth: 1920 + 'px',
							minHeight: viewHeight + 'px',
							backgroundColor: '#F5F6F7',
						}"
            ></router-view>
          </keep-alive>
        </transition>
        <transition name="fade-transform">
          <router-view
            v-if="!route.meta.keepAlive"
            :style="{
						zIndex: 0,
						// width: 1920 + 'px',
						minHeight: viewHeight + 'px',
						backgroundColor: '#F5F6F7',
					}"
          ></router-view>
        </transition>

      </el-main>

<!--    </el-container>-->
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import layoutFooter from "./layout-footer.vue";
import LayoutHeader from "./layout-header.vue";
export default {
  name: "layout",
  components:{
    LayoutHeader,layoutFooter
  },
  data(){
    return{
      LayoutHeaderHeight: 0, // 50
      layoutMarginLeft: 0,
      viewWidth: 0,
      viewHeight: 0,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    }
  },
  created() {
    // watch window size change
    window.addEventListener(
      "resize",
      () => {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
      },
      false
    );
    this.computedStyle();
  },
  watch: {
    windowWidth(val) {
      this.computedStyle();
    },
    windowHeight(val) {
      this.computedStyle();
    },
    route(val) {
      this.computedStyle();
    }
  },
  methods: {
    computedStyle() {
      let route = this.route;
      let meta = route.meta;
      let windowWidth = this.windowWidth;
      let windowHeight = this.windowHeight;
      if (meta.isShowLeftSider) {
        this.layoutMarginLeft = 0;
        this.viewWidth = windowWidth - this.layoutMarginLeft;
      } else {
        this.layoutMarginLeft = 0;
        this.viewWidth = windowWidth;
      }
      if (meta.isShowHeader) {
        // iview fix header heiget 64px
        this.LayoutHeaderHeight = 0;
        this.viewHeight = windowHeight - this.LayoutHeaderHeight - 250;
      } else {
        this.LayoutHeaderHeight = 0;
        this.viewHeight = windowHeight - 250;
      }
    },
    handleRefresh() {
      window.location.reload();
    }
  },
  computed: {
    path() {
      return this.$route.path;
    },
    route() {
      // console.log(this.$route.meta);
      return this.$route;
    },
    user() {
      return this.$store.state.user;
    },
    breadcrumbList() {
      return this.$route.meta.breadcrumb
    }
  }
}
</script>

<style scoped>
.el-main {
  overflow: hidden;
  min-width: 1280px;
}
.nav{
  background: none;
  width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
  /*padding: 20px 360px;*/
}
</style>



// WEBPACK FOOTER //
// src/framework/layout/layout.vue